import { render, staticRenderFns } from "./StorefrontOrderRoutingConfig.vue?vue&type=template&id=5bc42190"
import script from "./StorefrontOrderRoutingConfig.vue?vue&type=script&lang=js"
export * from "./StorefrontOrderRoutingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports